import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { BeneficiaireModalDetailFormationComponent } from '../modal/beneficiaire-modal-detail-formation/beneficiaire-modal-detail-formation.component';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-detail-beneficiaire',
	templateUrl: './detail-beneficiaire.component.html',
	styleUrls: ['./detail-beneficiaire.component.scss']
})
export class DetailBeneficiaireComponent implements OnInit {
	beneficiaire: Beneficiaire;
	confirmDeleteModalRef: BsModalRef;
	detailFormationModalRef: BsModalRef;
	competences: CareSkill[];
	isPlanificatrice: boolean;
	isDeletable: boolean;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isSAE = false;
	isAreaActive = false;

	labelBeneficiaireCapitalized: string;
	labelIntervenantCapitalizedPluralized: string;
	labelIntervenantCapitalized: string;
	labelInterventionPluralizedCapitalized: string;

	isFormReadOnly = true;
	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: false };

	/**
	 * Index de pagination de la liste des formations d'un beneficiaire
	 */
	currentPage: number;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	pairMissionRqEmployee: {
		missionRequest: MissionRequest;
		employeeName: string;
	}[] = [];

	listEmployee: Employee[] = [];

	MAX_NAME_CHAR = 25;
	NAME_PATTERN =
		"^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+( [0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+)*$";
	form = new FormGroup({
		firstName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		lastName: new FormControl('', [
			Validators.required,
			Validators.minLength(1),
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		address: new FormControl(new Address().label, [
			Validators.required,
			Validators.maxLength(60)
		]),
		email: new FormControl(''),
		tel: new FormControl(''),
		preferredEmployee1: new FormControl(''),
		preferredEmployee2: new FormControl(''),
		preferredEmployee3: new FormControl(''),
		incompatibleEmployee1: new FormControl(''),
		incompatibleEmployee2: new FormControl(''),
		incompatibleEmployee3: new FormControl(''),
		area: new FormControl('Non spécifié')
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService,
		private cacheService: CacheService,
		private toastService: ToastService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.cacheService.clearCache();
		this.labelBeneficiaireCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelIntervenantCapitalizedPluralized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelInterventionPluralizedCapitalized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENTION
			);

		this.isPlanificatrice = this.facade.dataStorageService.isPlanificatrice();

		this.isDeletable = this.isPlanificatrice;

		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.isSAE = this.facade.dataStorageService.isSAE();

		this.isAreaActive = this.facade.dataStorageService.isAreaActive();
		this.facade.careSkillService
			.getAllCareSkills()
			.subscribe((careSkills) => (this.competences = careSkills));

		/**
		 * Récupère le paramètre de la route
		 */
		const id = +this.route.snapshot.paramMap.get('id');
		/**
		 * Appel le back pour récupérer l'beneficiaire grâce à son id
		 */
		this.facade.beneficiaireService.getBeneficiaireById(id).subscribe({
			next: (beneficiaire: Beneficiaire) => {
				this.beneficiaire = beneficiaire;
				if (this.beneficiaire.address && this.beneficiaire.address.label) {
					this.isAddressDefault.value = true;
				}
				this.facade.employeeService
					.getAllActiveEmployees()
					.subscribe((data) => {
						this.listEmployee = data;
					});
				this.facade.formationService
					.getFormationsByBeneficiaireId(this.beneficiaire.id)
					.subscribe((listFormationsBeneficiaire) => {
						listFormationsBeneficiaire.forEach((missionRequest) => {
							const isMissionWithOnlyOneEmployee =
								missionRequest.nombreIntervenant === 1;
							let employeeName = 'Aucun ' + this.labelIntervenantCapitalized;
							if (isMissionWithOnlyOneEmployee) {
								this.facade.employeeService
									.getEmployeeByMissionRequestId(missionRequest.id)
									.subscribe({
										next: (employee: Employee) => {
											if (employee && employee.firstName && employee.lastName) {
												employeeName =
													employee.firstName + ' ' + employee.lastName;
											}
											this.pairMissionRqEmployee.push({
												missionRequest,
												employeeName
											});
										},
										error: (err) => {
											this.logger.error(err);
											this.pairMissionRqEmployee.push({
												missionRequest,
												employeeName
											});
										}
									});
							} else {
								employeeName =
									this.labelIntervenantCapitalizedPluralized + ' multiples';
								this.pairMissionRqEmployee.push({
									missionRequest,
									employeeName
								});
							}
						});
					});
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.goBack();
			}
		});
	}

	getBeneficiaireSkillsAsString(beneficiaire: Beneficiaire): string {
		if (!beneficiaire || !beneficiaire.careSkills) {
			return 'Sans';
		}

		const skills = beneficiaire.careSkills;
		if (skills.length > 0) {
			return skills.map((skill) => skill.name || 'Sans').join(' | ');
		}

		return 'Sans';
	}

	getMissionPlaceNameAndAddress(missionRequest: MissionRequest) {
		if (this.isSESSAD || this.isSAE) {
			let missionPlaceName = '';
			if (missionRequest.missionPlace) {
				missionPlaceName =
					missionRequest.missionPlace.nameDisplay +
					', ' +
					missionRequest.missionPlace.address.label;
			} else {
				missionPlaceName = 'Domicile du ' + this.labelBeneficiaireCapitalized;
			}
			return missionPlaceName;
		}
	}

	sortPairMissionRqEmployee() {
		this.pairMissionRqEmployee.sort((a, b) => {
			return this.sortOrder === 'asc'
				? new Date(a.missionRequest.date).getTime() -
						new Date(b.missionRequest.date).getTime()
				: new Date(b.missionRequest.date).getTime() -
						new Date(a.missionRequest.date).getTime();
		});
	}

	goBack(): void {
		this.router.navigate(['/gestion/beneficiaires/list']);
	}

	goEdit(beneficiaire: Beneficiaire): void {
		const link = ['/gestion/beneficiaires/edit', beneficiaire.id];
		this.router.navigate(link);
	}

	delete(beneficiaire: Beneficiaire): void {
		if (this.isDeletable) {
			this.facade.beneficiaireService
				.deleteBeneficiaire(beneficiaire.id)
				.subscribe({
					complete: () => {
						this.modalService.hide();
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.response,
							err.status
						);
					}
				});
		}
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	openModalDetailFormation(formation: MissionRequest): void {
		const initialState = {
			missionRequest: formation,
			beneficiaire: this.beneficiaire
		};
		this.detailFormationModalRef = this.modalService.show(
			BeneficiaireModalDetailFormationComponent,
			{
				class: 'custom-modal-side',
				initialState
			}
		);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();

		if (
			this.beneficiaire.address &&
			this.beneficiaire.address.label &&
			this.beneficiaire.address.latitude &&
			this.beneficiaire.address.longitude
		) {
			this.isAddressDefault.value = true;
		}
		this.isAddressSelected.value = false;
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	onSubmit() {
		if (this.form.valid) {
			this.isValidateButtonClicked.value = true;
			this.facade.beneficiaireService
				.updateBeneficiaire(this.beneficiaire)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.toastService.createHttpErrorToast(
							err.error.response,
							err.status
						);
					}
				});
		}
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
}
